import React from 'react';

const SvgStreetcar = ({ title, ...props }) => (
  <svg
    id="streetcar_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 50 50"
    xmlSpace="preserve"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <style>
      {'.streetcar_svg__st0{fill:#fff}.streetcar_svg__st1{fill:#8dc63f}'}
    </style>
    <path
      className="streetcar_svg__st0"
      d="M49.1 17.9h-3.4c-.2-.5-.3-.9-.5-1.4-1.1-2.6-2.7-4.9-4.7-6.9S36.2 6 33.6 4.9c-2.7-1.1-5.5-1.7-8.5-1.7s-5.8.6-8.5 1.7c-2.6 1.1-5 2.7-7 4.7S6 13.9 4.9 16.5c-.2.5-.4.9-.5 1.4H1c.3-.8.6-1.7.9-2.6 1.3-3 3.1-5.7 5.4-8 2.3-2.3 5-4.1 8-5.4 3.1-1.3 6.4-2 9.8-2 3.4 0 6.7.7 9.8 2 3 1.3 5.7 3.1 8 5.4 2.3 2.3 4.1 5 5.4 8 .2.9.6 1.8.8 2.6zM49.1 32.1c-.3.9-.6 1.8-.9 2.6-1.3 3-3.1 5.7-5.4 8-2.3 2.3-5 4.1-8 5.4-3.1 1.3-6.4 2-9.8 2-3.4 0-6.7-.7-9.8-2-3-1.3-5.7-3.1-8-5.4-2.3-2.3-4.1-5-5.4-8-.2-.9-.5-1.7-.8-2.6h3.4c.2.5.3 1 .5 1.4 1.1 2.6 2.7 4.9 4.7 6.9s4.3 3.6 6.9 4.7c2.7 1.1 5.5 1.7 8.5 1.7s5.8-.6 8.5-1.7c2.6-1.1 4.9-2.7 6.9-4.7s3.6-4.3 4.7-6.9c.2-.5.4-.9.5-1.4h3.5z"
    />
    <path
      className="streetcar_svg__st1"
      d="M24.8 20.8c9.6 0 13.3 6.9 13.5 8.4h-13c-9.4 0-13.1-6.7-13.5-8.3v-.1h13zM38.4 17.9H11.8c2.3-5 7.4-8.6 13.3-8.6s11 3.6 13.3 8.6zM38.4 32.1c-2.3 5-7.4 8.6-13.3 8.6s-11-3.5-13.3-8.6h26.6z"
    />
  </svg>
);

export default SvgStreetcar;
